import { useCallback } from "react";
import { useSelector } from "react-redux";

// Components
import { Label } from "../../../../../components/typography";
import {
  TextField,
  Textarea,
  Button,
  ToggleSwitch,
  Select
} from "../../../../../components/UI";

// Builders
import * as buttonDesignType from "../../../../../builders/buttonDesign.types";

// Styles
import { ServiceFormStyles } from "./serviceForm.styles";

const ServiceForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldTouched,
  setFieldValue,
  buttonText,
  dirty,
  hideButton
}) => {
  const { systemComponents } = useSelector(state => state.app);

  const handlePriceChange = useCallback(
    (e, fieldName) => {
      let inputValue = e.target.validity.valid
        ? parseInt(e.target.value, 0)
        : values.price;
      if (isNaN(inputValue)) {
        inputValue = "";
      }
      setFieldValue(fieldName, inputValue);
    },
    [values.price, setFieldValue]
  );

  const handleServiceTypeSelect = typeKey => {
    setFieldTouched("serviceTypeKey", true);
    setFieldValue("serviceTypeKey", typeKey);
  };

  return (
    <ServiceFormStyles>
      <div className="inputContainer">
        <Label>Service Title</Label>
        <TextField
          value={values.title}
          name="title"
          onBlur={handleBlur}
          onChange={handleChange}
          touched={touched.title}
          error={errors.title}
          placeholder="Enter a title"
        />
      </div>

      <div className="inputContainer">
        <Label>Service Type</Label>
        <Select
          value={values.serviceTypeKey}
          options={systemComponents.serviceTypes.map(st => ({
            value: st.typeKey,
            label: st.name,
            name: st.name
          }))}
          onChange={val => handleServiceTypeSelect(val[0]?.value)}
          handleTouched={() => setFieldTouched("serviceTypeKey", true)}
          touched={touched.serviceTypeKey}
          error={errors.serviceTypeKey}
          placeholder="Select service type"
        />
      </div>

      <div className="inputContainer">
        <Label>Service Price</Label>
        <TextField
          value={values.price}
          onBlur={handleBlur}
          name="price"
          touched={touched.price}
          error={errors.price}
          onChange={e => handlePriceChange(e, "price")}
          placeholder="Enter a price"
        />
      </div>

      <div className="inputContainer">
        <Label>Service Description</Label>
        <Textarea
          value={values.description}
          name="description"
          onBlur={handleBlur}
          onChange={handleChange}
          touched={touched.description}
          error={errors.description}
          placeholder="Enter a short description about this service"
        />
      </div>

      <div className="availabilityRow">
        <div className="availabilityLeft">
          <span className="availabilityLabel">Available</span>
          <span className="availabilityHint">
            {values.available
              ? "This item is visible to customers"
              : "This item is hidden from customers"}
          </span>
        </div>
        <ToggleSwitch
          name="available"
          value={values.available}
          handleChange={setFieldValue}
        />
      </div>

      {!hideButton && (
        <div className="buttonsContainer">
          {(dirty === undefined || dirty) && (
            <Button type="submit" buttonDesignType={buttonDesignType.PRIMARY}>
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </ServiceFormStyles>
  );
};

export default ServiceForm;
